import React from "react";
import "./why-choose.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Reveal from "./Components/Reveal/Reveal";

const whyChooseUs = [
  { title: "We Understand Corporate Culture", text: "Ignite Events is built around a deep understanding of what corporate teams need, from building stronger connections to celebrating success. We create experiences that align with company values, enhance communication, and leave teams feeling re-energized and inspired." },
  { title: "Tailored Experiences, Not Templates", text: "Every company is different. We don't offer one-size-fits-all packages. We listen, design, and deliver bespoke events that reflect your team's personality, culture, and goals. Whether it's a leadership retreat, gala dinner or conference, every detail is crafted around your vision." },
  { title: "Seamless Event Management", text: "From the first idea to the final farewell, Ignite manages everything including planning, logistics, suppliers, venues, and on the day coordination so you can focus on your people while we handle the rest. We bring clarity, creativity, and calm to every project." },
  { title: "Experienced Professionals, Personal Touch", text: "Our team combines years of experience in corporate wellness and events with a personal, hands on approach. We know the importance of precision and professionalism and we care about every single guest's experience." },
  { title: "Inspiring Locations & Trusted Partnerships", text: "We work with Ireland's top venues and suppliers, ensuring quality, reliability, and wow factor. Whether your event takes place in a five star hotel, a countryside estate, or outdoors in nature, Ignite brings the expertise to make it shine." },
  { title: "Results That Last Beyond the Day", text: "Our events don't just entertain, they ignite motivation, connection, and purpose that carry back into the workplace. We aim to create memorable experiences that strengthen teams and drive engagement long after the event ends." },
];

export default function WhyChoose() {
  return (
    <div className="app-container">
      <Navbar />
      <main className="why-choose-main">
        <h1>Why Choose Ignite Events</h1>
        <div className="why-choose-grid">
          {whyChooseUs.map((item, index) => (
            <Reveal
              as="article"
              key={index}
              className="why-choose-card"
              delay={(index % 2) * 90}
            >
              <span className="why-choose-number">{index + 1}</span>
              <h2>{item.title}</h2>
              <p>{item.text}</p>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
